import { AxiosResponse } from 'axios'
import { request, requestNoInterceptors } from '../request'
import { LoginResponse, Login2FAResponse } from '@models/api/LoginResponse'
import type { CallbackTypes } from 'vue3-google-login'

export const auth = {
  login: function (
    email: string,
    password: string
  ): Promise<AxiosResponse<LoginResponse | Login2FAResponse>> {
    return request.post('login', {
      email,
      password
    })
  },

  check2FA: function (
    email: string,
    code: string
  ): Promise<AxiosResponse<LoginResponse>> {
    return request.post('login/check2FA', {
      email,
      code
    })
  },

  loginWithGoogle: function (
    googleUser: CallbackTypes.CredentialPopupResponse
  ) {
    return request.post('login/google', {
      token: googleUser.credential
    })
  },

  register: function (
    firstName: string,
    lastName: string,
    email: string,
    password: string
  ): Promise<AxiosResponse<LoginResponse>> {
    return request.post('register', {
      first_name: firstName,
      last_name: lastName,
      email,
      password
    })
  },

  registerESRI: function (
    nombre: string,
    apellidos: string,
    empresa: string,
    cargo: string,
    email: string,
    password: string
  ): Promise<AxiosResponse<any>> {
    return request.post('register/esri', {
      first_name: nombre,
      last_name: apellidos,
      org_name: empresa,
      org_usr_role: cargo,
      email,
      password
    })
  },

  passwordLost: function (email: string): Promise<AxiosResponse> {
    return request.post('/login/passwordLost', {
      email: email
    })
  },

  resetPasswordLost: function (
    id: string,
    password: string
  ): Promise<AxiosResponse> {
    return request.post(
      `/login/resetPasswordLost`,
      { password: password },
      {
        params: {
          id: id
        }
      }
    )
  },

  resetPassword: function (
    currentPassword: string,
    newPassword: string
  ): Promise<AxiosResponse> {
    return request.post('/login/resetPassword', {
      currentPassword: currentPassword,
      newPassword: newPassword
    })
  },

  validate: async function () {
    return requestNoInterceptors.get('token')
  },

  logout: function () {
    return request.get('login/logout')
  }
}
